import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, takeUntil } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { ConfirmDialogComponent } from 'src/app/shared/global/confirm-dialog/confirm-dialog.component';
import { BulkServicesService } from '../../../../core/api/services';
import {
  confirmDialogConfig,
  DialogService,
} from '../../../../core/services/dialog.service';
import { FileService } from '../../../../core/services/file.service';
import { MobileNumbersService } from '../../../../core/services/mobile-numbers.service';
import { UtilityService } from '../../../../core/services/utility.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-bulk-numbers-delete-from-xlsx',
    templateUrl: './bulk-numbers-delete-from-xlsx.component.html',
    styleUrls: ['./bulk-numbers-delete-from-xlsx.component.scss'],
    imports: [BaseFormModule]
})
export class BulkNumbersDeleteFromXlsxComponent
  extends BaseFormPageComponent
  implements OnInit
{
  pageVocabs = 'pages.bulkNumberInformation.form.';
  apiModel: any = {};
  excelTypes: string[] = ['xls', 'xlsx', 'csv'];

  constructor(
    protected bulkService: BulkServicesService,
    protected dialogService: DialogService,
    protected fileService: FileService,
    protected mobileNumbersService: MobileNumbersService,
    protected UtilityService: UtilityService
  ) {
    super();
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
      this.getVocabs();
      this.initForm();
      this.fields = 'pages.bulkNumberInformation.deleteFromFile.fields.';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      inputFile: new FormControl(''),
      mobileFieldName: new FormControl(''),
    });
  }

  getConfirmDialog(
    config: confirmDialogConfig
  ): MatDialogRef<ConfirmDialogComponent, any> {
    return this.dialogService.confirmDialog(config);
  }

  checkFile(file) {
    try {
      if (!file) return;

      let fileType = this.fileService.getFileType(file);

      if (this.excelTypes.indexOf(fileType) > -1) this.readExcelFile(file);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  readExcelFile(file) {
    this.loading = true;
    // read file
    this.fileService
      .readExcelFile(file)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe((data) => {
        try {
          let values: any[] = [];
          let text: string;

          if (data.jsonData.length > 0)
            data.jsonData.forEach((item) => {
              Object.values(item).forEach((value) => {
                values.push(value);
              });
            });

          text = values?.join('\n');

          if (text) {
            let numbers = UtilityService.getNumbersFromString(text);
            if (numbers) {
              this.checkMobileNumbers(numbers);
              this.cd.detectChanges();
            }
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.infrastructure
          );
        }
      });
  }

  checkMobileNumbers(text: string) {
    try {
      //گرفتن شماره موبایل های صحیح
      let correctMobileNumberArray: string[] =
        this.mobileNumbersService.getCorrectMobileNumbersFromText(text);

      //ثبت کردن مدل نهایی
      this.setModel(correctMobileNumberArray);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#region Set Output Model
  setModel(data: any) {
    try {
      if (!data) return;

      this.apiModel.mobiles12 = [];
      this.apiModel.mobiles12 = data;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
  //#endregion
}
